import { render, staticRenderFns } from "./SidebarApp.vue?vue&type=template&id=b8ddd8c4&"
import script from "./SidebarApp.vue?vue&type=script&lang=js&"
export * from "./SidebarApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports